<template>
	<div>
		<el-dialog :close-on-click-modal="false" title="请选取地址" :visible="positionDialog"
			:before-close="closePositionDialog" @close="closePositionDialog" append-to-body width="800px">
			<!-- <input type="text" ref="search" placeholder="Search for a location"> -->
			<div class="flex benben-flex-layout flex-wrap align-center yangshi_0">
				<!-- v-model="sou_name" -->
				<GmapAutocomplete class="yangshi_1"  style="z-index: 3000;" @place_changed='setPlace' :value="sou_name" />
				<div class="pointer addresDetal_4_2" @click='addMarker'>Add</div>
			</div>
			<GmapMap :center="jingwei" :zoom="12" map-type-id="terrain" @click="handleMapClick"
				style="width: 100%; height: 400px">
				<GmapMarker v-for="(m, index) in markers" :key="index" :position="m.position" :clickable="true"
					:draggable="true" @dragend="tuodong" />
			</GmapMap>
			<span slot="footer">
			  <el-button @click="closePositionDialog" size="medium">取消</el-button>
			  <el-button type="primary" @click="handlePositionDialog" size="medium"
			    >确定</el-button
			  >
			</span>

		</el-dialog>
	</div>


</template>

<script>
	export default {
		props: {
			positionDialog: {
				type: Boolean,
				default: false,
			},

		},
		data() {
			return {
				sou_name:'',
				currentPlace: '',
				jingwei:{lat: 37.7749, lng: -122.4194},
				// {
				// 	position: {
				// 		lat: 34.72374,
				// 		lng: 113.6412
				// 	}
				// }
				markers: [], // 用于存储标记的位置信息
				places: [], // 用于存储搜索结果的位置信息


			};
		},
		watch: {
			// 监听事件 如果打开了弹框才加载地图，否则不加载地图
			positionDialog(type) {
				if (type) {
					console.log('执行1232')
					//type True or false
					this.initMap();
				}
			},
		},

		methods: {
			// 关闭弹框
			closePositionDialog() {
				this.sou_name = "";
				// this.position = {}
				this.$emit("update:positionDialog", false);
			},
			// 点击确定
			handlePositionDialog() {
				
				let date = {
					name:this.sou_name,
					lat: this.jingwei.lat,
					lng: this.jingwei.lng
				}
				this.$emit("selPosition", date); //把选择的位置传给父组件
			    this.closePositionDialog();
			},
			initMap() {},
			setPlace(place) {
				// console.log(place, 1111111111111)
				this.currentPlace = place;
				// console.log(this.currentPlace.geometry.location.lat(), this.currentPlace.geometry.location.lng(),
				// 	1111111111111)
			},
			addMarker() {
				if (this.currentPlace) {
					const marker = {
						lat: this.currentPlace.geometry.location.lat(),
						lng: this.currentPlace.geometry.location.lng(),
					};
					this.jingwei = marker
					// this.markers.push({
					// 	position: marker
					// });
					// this.places.push(this.currentPlace);
					// this.center = marker;
					this.fetchAddress()
					this.currentPlace = null;
				}else{
				}
				console.log(this.markers,this.jingwei,'数据信息1234')
			},
			tuodong(event){
				console.log(event,'拖动maka点的信息')
			},
			handleMapClick(event) {
				const marker = {
					lat: event.latLng.lat(),
					lng: event.latLng.lng(),
				};
				this.jingwei = marker
				console.log(marker, '地图点击的地址信息')
				this.fetchAddress()
			},
			fetchAddress() {
			      const geocoder = new google.maps.Geocoder();
			      const latlng = { lat: this.jingwei.lat, lng: this.jingwei.lng };
			      geocoder.geocode({ location: latlng }, (results, status) => {
			        if (status === 'OK') {
						let list = []
						list.push({
							position: latlng
						});
						this.markers = list
					  console.log(results[0],'参数信息1234')
						this.sou_name = results[0].formatted_address
			        //   if (results[0]) {
			        //     this.address = results[0].formatted_address;
			        //   } else {
			        //     this.address = 'No results found';
			        //   }
			        } else {
			        //   this.address = `Geocoder failed due to: ${status}`;
			        }
			      });
			}
		},
	};
</script>
<style lang="scss">

  .pac-container {
    z-index: 9999;
  }
  .gm-style-mtc-bbw{
	  display: none;
  }
</style>
<style lang="scss" scoped>
	::v-deep {
		.el-dialog__body{
			padding-top: 0 !important;
		}
		
		.vue-maps-autocomplete {
		  z-index: 4000 !important;
		}

		.el-dialog__wrapper{
			z-index: 500 !important;
		}
	}
	
	.addresDetal_4_2{
		width: 80px;
		height: 48px;
		background: #FF770F;
		border-radius: 8px 8px 8px 8px;
		font-weight: 400;
		font-size: 16px;
		color: #FFFFFF;
		line-height: 48px;
		text-align: center;
		margin: 0px 0 0 32px;
	}
	.yangshi_1{
		height: 48px;
		width: 600px;
		border: 1px solid #DCDFE6;
		border-radius: 4px;
		padding: 0 12px;
	}
	.yangshi_0{
		margin: 24px 0 32px 0;
	}
</style>
